module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/evt-step1-bba43372c73541889e0954a2d9c465c1.svg";